import { useRef } from 'react'
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from '@chakra-ui/react'

interface WelcomeModalProps {
  isOpen: boolean
  onClose: () => void
}

/**
 * Welcome modal displayed when a user completes their profile for the first time
 * Informs users they now have full access to the ALS Registry
 */
const WelcomeModal = ({ isOpen, onClose }: WelcomeModalProps) => {
  const leastDestructiveRef = useRef<HTMLButtonElement>(null)

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      leastDestructiveRef={leastDestructiveRef}
      isCentered
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader>Welcome to the ALS Registry!</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>
            You now have access to the ALS Registry. Please go ahead and
            complete the remaining profile steps so we have all of your
            important information.
            <br />
            <br />
            Once you are done click on the Dashboard to begin completing your
            monthly reports.
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={leastDestructiveRef}
              colorScheme='purple'
              onClick={onClose}
            >
              Got it!
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}

export default WelcomeModal
